var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.868,
    y: 11.247,
    width: 26,
    height: 3,
    rx: 0.6,
    transform: "rotate(45 12.868 11.247)",
    fill: "#6C7889"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.747,
    y: 29.632,
    width: 26,
    height: 3,
    rx: 0.6,
    transform: "rotate(-45 10.747 29.632)",
    fill: "#6C7889"
  })));
};

export default SvgClose;